/**
 * CMS locale constants (match Prismic locales).
 * UI codes (en, es) map to these values via `UI_TO_CMS_MAP`.
 */

export const LANGUAGES = {
    // CMS/Prismic locale codes
    ENGLISH: 'en-au',
    SPANISH: 'es-es',
} as const;

// Map the shorter UI language codes used in settings to the exact CMS locale
// strings required by Prismic. Keep this mapping explicit so it's obvious how
// UI choices translate into CMS queries.
export const UI_TO_CMS_MAP = {
    en: LANGUAGES.ENGLISH,
    es: LANGUAGES.SPANISH,
} as const;

export const DEFAULT_LANGUAGE = LANGUAGES.ENGLISH;
export const SUPPORTED_LANGUAGES = Object.values(LANGUAGES);

export type SupportedLanguage = typeof LANGUAGES[keyof typeof LANGUAGES];
